module.exports = __webpack_public_path__ + "static/media/skirtWithFlowers.b61e4fe2.jpg";